export function getCookie(name) {
	const value = `; ${document.cookie}`;
	const parts = value.split("; " + name + "=");
	if (parts.length == 2) return parts.pop().split(";").shift();
	return false
}

export function setCookie(name, value, props) {
	props = props || {};
    var exp = props.expires;

    props.path = '/';

	if (window.location.protocol === "https:") {
		props.Secure = 'Secure';
	}

    if (typeof exp == "number" && exp) {
        var d = new Date();
        d.setTime(d.getTime() + (exp*24*60*60*1000));
        exp = props.expires = d;
    }

    if(exp && exp.toUTCString) { props.expires = exp.toUTCString() };

    value = encodeURIComponent(value);

    var updatedCookie = name + "=" + value;

    for(var propName in props){
        updatedCookie += "; " + propName;
        var propValue = props[propName];
        if(propValue !== true){ updatedCookie += "=" + propValue };
    }

    document.cookie = updatedCookie;
}
